import React from "react";
import { Box, Chip, Stack } from "@mui/material";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import GroupsIcon from "@mui/icons-material/Groups";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";

const MessageSenderHeader = ({
  displayName,
  channelLabel,
  isAiAgent,
  isChatbot,
  isGroupParticipant,
  groupName,
  align = "left",
  color = "inherit",
  isOwnMessage = false,
  isTeamPeer = false,
  spokenOnCall = false,
  spokenLabel = "Falado na ligação",
}) => {
  if (!displayName && !channelLabel && !isOwnMessage && !spokenOnCall) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.25,
        mb: 0.5,
        textAlign: align,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 0.5,
          justifyContent: align === "right" ? "flex-end" : "flex-start",
          color,
        }}
      >
        {isAiAgent && (
          <AutoAwesomeIcon sx={{ fontSize: 16, color: "inherit" }} />
        )}
        {isChatbot && !isAiAgent && (
          <SmartToyOutlinedIcon sx={{ fontSize: 16, color: "inherit" }} />
        )}
        {isOwnMessage ? (
          <Chip
            label="Você"
            size="small"
            sx={{
              height: 20,
              fontSize: "0.65rem",
              fontWeight: 700,
              bgcolor: "rgba(255,255,255,0.22)",
              color: "inherit",
              border: "1px solid",
              borderColor: "rgba(255,255,255,0.35)",
            }}
          />
        ) : (
          <>
            {isTeamPeer && (
              <Chip
                label="Equipe"
                size="small"
                variant="outlined"
                sx={{
                  height: 20,
                  fontSize: "0.65rem",
                  fontWeight: 600,
                  borderColor: "currentColor",
                  color: "inherit",
                  opacity: 0.9,
                }}
              />
            )}
            {displayName ? (
              <Box
                component="span"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "0.8rem", sm: "0.85rem" },
                  minWidth: 0,
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  lineHeight: 1.3,
                }}
              >
                {displayName}
              </Box>
            ) : null}
          </>
        )}
        {isAiAgent && displayName !== "Agente de IA" && (
          <Box component="span" sx={{ opacity: 0.75, fontWeight: 400, fontSize: "0.8rem" }}>
            (Agente de IA)
          </Box>
        )}
        {isChatbot && displayName !== "Chatbot" && (
          <Box component="span" sx={{ opacity: 0.75, fontWeight: 400, fontSize: "0.8rem" }}>
            (Chatbot)
          </Box>
        )}
        {channelLabel && (
          <Box
            component="span"
            sx={{
              opacity: 0.85,
              fontSize: { xs: "0.72rem", sm: "0.8rem" },
              fontWeight: 400,
              flexShrink: 0,
              whiteSpace: "nowrap",
            }}
          >
            {`via ${channelLabel}`}
          </Box>
        )}
      </Box>
      {(isGroupParticipant || spokenOnCall) && (
        <Stack
          direction="row"
          spacing={0.5}
          justifyContent={align === "right" ? "flex-end" : "flex-start"}
        >
          {spokenOnCall && (
            <Chip
              icon={<RecordVoiceOverOutlinedIcon sx={{ fontSize: "14px !important" }} />}
              label={spokenLabel || "Falado na ligação"}
              size="small"
              variant="outlined"
              sx={{ height: 20, fontSize: "0.68rem" }}
            />
          )}
          {isGroupParticipant && (
            <Chip
              icon={<GroupsIcon sx={{ fontSize: "14px !important" }} />}
              label={groupName ? `Grupo · ${groupName}` : "Grupo WhatsApp"}
              size="small"
              variant="outlined"
              sx={{
                height: 20,
                fontSize: "0.68rem",
                maxWidth: { xs: "100%", sm: "none" },
                "& .MuiChip-label": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  px: 0.75,
                },
              }}
            />
          )}
        </Stack>
      )}
    </Box>
  );
};

export default MessageSenderHeader;
